import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";

import { useEditAgreementAppMutation } from "@modules/agreementApps/services/mutation/editAgreementApp/mutation";
import { AgreementAppFormValues, agreementAppSchema } from "@modules/agreementApps/validations";

export function useAgreementAppEditForm() {
  const { id } = useParams();
  const { mutateAsync, isPending } = useEditAgreementAppMutation(id as string);

  const methods = useForm<AgreementAppFormValues>({
    resolver: zodResolver(agreementAppSchema()),
    mode: "onBlur",
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
    formState: { errors },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}
